import {
  EmailBlockType,
  EmailLocale,
  IEmailBlock,
} from "../../interfaces/emailTemplate.interface";

export const LOCALE_ORDER: EmailLocale[] = [
  EmailLocale.English,
  EmailLocale.French,
  EmailLocale.German,
  EmailLocale.Italian,
  EmailLocale.Dutch,
];

export const LOCALE_LABELS: Record<string, string> = {
  en: "🇬🇧 English",
  fr: "🇫🇷 French",
  de: "🇩🇪 German",
  it: "🇮🇹 Italian",
  nl: "🇳🇱 Dutch",
};

export const BLOCK_TYPE_LABELS: Record<EmailBlockType, string> = {
  text: "Paragraph",
  heading: "Heading",
  code: "Code / OTP",
  button: "Button",
  list: "List",
  table: "Table",
};

export const BLOCK_TYPES: EmailBlockType[] = [
  "text",
  "heading",
  "code",
  "button",
  "list",
  "table",
];

export function newBlock(type: EmailBlockType): IEmailBlock {
  switch (type) {
    case "list":
      return { type, ordered: false, items: [""] };
    case "table":
      return { type, rows: [{ label: "", value: "" }] };
    case "button":
      return { type, text: "", href: "" };
    default:
      return { type, text: "" };
  }
}

/**
 * Builds sample data for the preview from a template's declared params.
 * Booleans (show_*, is_*) default true; code/otp get a sample code.
 */
export function sampleParams(params: string[]): Record<string, unknown> {
  const data: Record<string, unknown> = {};
  for (const param of params) {
    if (/^(show|is|has|enable|can)([_A-Z]|$)/.test(param)) data[param] = true;
    else if (/code|otp/i.test(param)) data[param] = "482913";
    else data[param] = param.replace(/_/g, " ");
  }
  return data;
}
